import { Card, CardContent } from "@shared/ui/card";
import { Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@shared/ui/tooltip";
import { PageHeader } from "@shared/components/PageHeader";

interface QualityItem {
  label: string;
  count: number;
  percent: number;
  color: string; // Tailwind color classes
}

interface MeterReadingQualityProps {
  data?: {
    normalCount?: number;
    normalPercentage?: number;
    faultyCount?: number;
    faultyPercentage?: number;
    rcntCount?: number;
    rcntPercentage?: number;
  };
}

export const MeterReadingQuality = ({ data }: MeterReadingQualityProps) => {
  const qualityData: QualityItem[] = [
    {
      label: "Normal",
      count: data?.normalCount ?? 0,
      percent: data?.normalPercentage ?? 0,
      color: "bg-green-500",
    },
    {
      label: "Faulty",
      count: data?.faultyCount ?? 0,
      percent: data?.faultyPercentage ?? 0,
      color: "bg-orange-400",
    },
    {
      label: "RCNT",
      count: data?.rcntCount ?? 0,
      percent: data?.rcntPercentage ?? 0,
      color: "bg-red-500",
    },
  ];

  return (
<Card className="shadow-sm">
  <div className="flex items-center justify-between px-4 ">
    <PageHeader
      title="Meter Reading Quality"
      subtitle="Counts by reading condition in this route."
    />

    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Info className="w-4 h-4 text-gray-400 cursor-help hover:text-gray-600" />
        </TooltipTrigger>
        <TooltipContent>
          <p className="mb-2">
            Distribution of readings by condition. Spikes in Faulty/RCNT may
            indicate device or access issues.
          </p>
          <p>
            Optimization: Review RCNT locations and consider device maintenance
            for Faulty meters.
          </p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  </div>

  {/* Quality Bars */}
  <div className="space-y-4 p-4 pt-2">
    {qualityData.map((item) => (
      <div key={item.label}>
        <div className="flex justify-between items-center mb-1">
          <div className="flex items-center gap-2">
            <span className={`w-2.5 h-2.5 rounded-full ${item.color}`}></span>
            <span className="text-sm text-gray-700">{item.label}</span>
          </div>
          <span className="text-sm text-gray-700">
            {item.count} ({item.percent}%)
          </span>
        </div>

        <div className="w-full bg-gray-100 rounded-full h-2">
          <div
            className={`${item.color} h-2 rounded-full transition-all duration-500`}
            style={{ width: `${item.percent}%` }}
          ></div>
        </div>
      </div>
    ))}
  </div>
</Card>

  );
};
